import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

const meses = {
  1: "Enero",
  2: "Febrero",
  3: "Marzo",
  4: "Abril",
  5: "Mayo",
  6: "Junio",
  7: "Julio",
  8: "Agosto",
  9: "Septiembre",
  10: "Octubre",
  11: "Noviembre",
  12: "Diciembre"
};

const mesesOpts = [];
for (const key in meses) {
  mesesOpts.push({
    label: meses[key],
    value: key
  });
}

const currentYear = new Date().getFullYear();
const aniosOpts = [{ label: currentYear - 1, value: currentYear - 1 }];

export type Inputs = "mes" | "anio";

export type Buttons = "buscar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "mes",
      label: "* Mes",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: mesesOpts
      }
    },
    {
      name: "anio",
      label: "Año",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: currentYear.toString(),
        data: aniosOpts
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 2 },
      component: IButtonBuilder
    }
  ],
  validations: {
    mes: {
      requiredMes: {
        validator: value => !value,
        message: () => "Campo obligatorio"
      }
    }
  },
  rows: [["mes", "anio", "buscar"]]
};
